export const preferencesConstants = {
    SET_LANGUAGE: "SET_LANGUAGE",
    SET_UNIT_SYSTEM: "SET_UNIT_SYSTEM",
    SET_DATE: "SET_DATE",
    SET_TIME: "SET_TIME",
    SET_WEEK_START_DAY: "SET_WEEK_START_DAY",
    SET_THOUSAND_SEPARATOR: "SET_THOUSAND_SEPARATOR",
    SET_DECIMAL_SEPARATOR: "SET_DECIMAL_SEPARATOR",
    SET_CAUDAL: "SET_CAUDAL",
    SET_VOLUME: "SET_VOLUME",
    SET_PREASURE: "SET_PREASURE",
    SET_LENGTH: "SET_LENGTH",
    SET_AREA: "SET_AREA",
    SET_PREFERENCES: "SET_PREFERENCES",
    SET_UNIT_PREFERENCES: "SET_UNIT_PREFERENCES",
};
